import type { PaymentType } from '#src/app/shared/utils/payments';

import { usePromoteFormState } from '../../../formContext/formState';
import { useTracking } from '../useTracking';

export function useBeforeToken(): (paymentType: PaymentType) => Promise<boolean> {
	const [, { clearGeneralErrorMessage, setLoading }] = usePromoteFormState();
	const { trackSubmit } = useTracking();

	return async function beforeToken(paymentType: PaymentType): Promise<boolean> {
		clearGeneralErrorMessage();
		setLoading();
		trackSubmit({ paymentType });
		return Promise.resolve(true);
	};
}
